//处理时间转换
const myDate = new Date()//获取当前时间

const yearList = []//年份数组保存最近5年的年份[2018,2017,2016,2015,2014]
let unitYearList = []//年份数组保存最近5年的年份[2018年,2017年,2016年,2015年,2014年]

const getYears = function () {
    //当前年份
    let currentYear = myDate.getFullYear()
    for ( var i = 0 ; i < 5 ; i++ ) {
        yearList.push( currentYear - i )
    }
    unitYearList = yearList.map( item => {
        return `${item}年`
    })
}

getYears()

const findIndex = function () {
    let current = myDate.getMonth()//得到当前月份下标
    return current
}

const findYearIndex = function (time) {

  let year = time.split('/')[0]//外部调用传参，将其进行分割，判断当前年份是否与传入的相等
  let i
  yearList.map( (item, index) => {
    if ( item == year ) {
      i = index
    }
  })
  return i//得到当前年份下标
}

const findMonthIndex =  function (time) {
  let month = time.split('/')[1]
  return month-1
}

let Monthslots = function ( begin_time, end_time ) {
  return [
      {//开始时间年份
          flex: 1,
          values: unitYearList,
          className: 'slot1',
          textAlign: 'center',
          defaultIndex: !begin_time ? 0 : findYearIndex(begin_time),
      },
      {//开始月份
          flex: 1,
          values: ['1月', '2月', '3月', '4月', '5月', '6月','7月','8月','9月','10月','11月','12月'],
          className: 'slot3',
          textAlign: 'center',
          defaultIndex: !begin_time ? findIndex() : findMonthIndex(begin_time),
      },{
          divider: true,
          content: '-',
          className: 'slot2'
      },
      {
          flex: 1,
          values: unitYearList,
          className: 'slot1',
          textAlign: 'center',
          defaultIndex: !end_time ? 0 : findYearIndex(end_time),
      },
      {
          flex: 1,
          values: ['1月', '2月', '3月', '4月', '5月', '6月','7月','8月','9月','10月','11月','12月'],
          className: 'slot3',
          textAlign: 'center',
          defaultIndex: !end_time ? findIndex() : findMonthIndex(end_time),
      },
  ]
}

let singleMonthslots = function ( begin_time ) {
    return [
        {//开始时间年份
            flex: 1,
            values: unitYearList,
            className: 'slot1',
            textAlign: 'center',
            defaultIndex: !begin_time ? 0 : findYearIndex(begin_time),
        },
        {//开始月份
            flex: 1,
            values: ['1月', '2月', '3月', '4月', '5月', '6月','7月','8月','9月','10月','11月','12月'],
            className: 'slot3',
            textAlign: 'center',
            defaultIndex: !begin_time ? findIndex() : findMonthIndex(begin_time),
        },{
            divider: true,
            className: 'slot2'
        },
    ]
  }
  

let AreaSlots = [
    {
        flex: 1,
        values: ['深圳','海南','北京','上海','成都'],
        className: 'area',
        textAlign: 'center',
    }
]

export default {
    Monthslots,
    singleMonthslots,
    AreaSlots
}



// WEBPACK FOOTER //
// ./src/assets/js/slotsList.js